import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

const getHelperDataSuccess = (data) => {
  const noData = isObjectEmpty(data.Data)
  return {
    type: actionTypes.GET_HELPER_DATA,
    payload: {
      helperData: noData ? {} : data.Data,
    },
  };
};

export const getHelperData = () => async (dispatch) => {
  return await apiCall
    .axiosGet(`${API_BASE_URL}/HelperData`)
    .then((response) => {
      if (response) {
        dispatch(getHelperDataSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
